export enum ChatAppEnum {
    'WeChat.exe' = '微信',
    'Telegram.exe' = 'Telegram',
    'Skype.exe' = 'Skype',
    'WhatsApp.exe' = 'WhatsApp',
}